import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { AppointmentRequestDTO } from 'app/model/appointment/appointementRequestDTO.model';

@Injectable({
    providedIn: 'root'
})
export class AppointmentRequestService {
    private apiUrl = `${environment.API_URL}/api/appointment/request`;

    constructor(private http: HttpClient) { }

    getAppointmentsRequest(index: number, size: number, sortField: string, sortDirection: string): Observable<AppointmentRequestDTO[]> {
        const params = {
            index: index,
            size: size,
            sort: `${sortField},${sortDirection}`
        };
        return this.http.get<AppointmentRequestDTO[]>(this.apiUrl, { params });
    }

    createAppointmentRequest(appointmentRequest: AppointmentRequestDTO): Observable<AppointmentRequestDTO> {
        return this.http.post<AppointmentRequestDTO>(this.apiUrl, appointmentRequest);
    }

    updateAppointmentRequest(appointment: AppointmentRequestDTO): Observable<AppointmentRequestDTO> {
        return this.http.put<AppointmentRequestDTO>(this.apiUrl, appointment);
    }

    getAppointmentRequest(publicId: string): Observable<AppointmentRequestDTO> {
        return this.http.get<AppointmentRequestDTO>(`${this.apiUrl}/${publicId}`);
    }

    deleteAppointmentRequest(publicId: string) {
        return this.http.delete(`${this.apiUrl}/${publicId}`);
    }
}